<template>
  <modal
    id="modal-demo"
    ref="modal"
    v-model="open"
    class="prp-terms-modal"
    @hide="cancelModal()"
  >
    <div
      slot="header"
    >
      <a
        class="close"
        @click="cancelModal()"
      ><i
        class="typcn typcn-delete"
        aria-hidden="true"
      /></a>
      <h3>
        <i
          class="typcn typcn-document-text"
          aria-hidden="true"
        />{{
          $t('ORP_TERMS_MODAL_HEADER')
        }}
      </h3>
    </div>
    <div>
      <div class="panel panel-default">
        <div class="panel-body">
          <p class="prp-terms-text">
            {{ orpDetails.termsAndConditions }}
          </p>
        </div>
      </div>
    </div>
    <div
      slot="footer"
    >
      <button
        v-t="'CLOSE'"
        type="button"
        class="button button--white-hover-grad pulse"
        @click="cancelModal()"
      />
    </div>
  </modal>
</template>

<script>

import messages from '../locales';
import sharedMessages from '@/core/locales';

export default {
  props: {
    openModal: {
      type: Boolean,
      default() {
        return false;
      },
    },
    orpDetails: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: function() {
    return {
      open: this.openModal
    };
  },
  watch: { 
    openModal: function(newVal) { // watch it
      this.open = newVal;
    }
  },
  methods: {
    cancelModal() {
      this.$emit('close-modal');
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>

</style>